(function($){
  
  // Hero Section Slider
  function sortHeroSlider($items) {
    var listWrapper = $items;
    var sortedItems = listWrapper.find("li").sort(function(a, b) {      
        var contentA = parseInt($(a).find('img').attr('alt').split('ssorder:')[1].split(']')[0]);
        var contentB = parseInt($(b).find('img').attr('alt').split('ssorder:')[1].split(']')[0]);
      
        return contentB > contentA ? -1 : contentA > contentB ? 1 : 0;
    });
    
    listWrapper.find("li").remove();
    listWrapper.append(sortedItems.slice(0,10)).bxSlider({
      mode: 'fade',
      auto: true,
      infiniteLoop: true,
      startSlide: 0,
      speed: 1000,
      controls: true,
      pager: true,
      maxSlides: 1,
      moveSlides: 1,
      pause: 4000,
      slideZIndex: 0,
      responsive: true,
      touchEnabled: (navigator.maxTouchPoints > 0)
    });
  }

  if ($('.vae-hero-slider-wrapper').length) {
    sortHeroSlider($('.vae-hero-slider'));  
  }

  function sortItemsOnlyByIndexDescending($items) {
    var listWrapper = $items;
    var sortedItems = listWrapper.find("li").sort(function(a, b) {
      var contentA = parseInt($(a).data("id"));
      var contentB = parseInt($(b).data("id"));
      return contentA > contentB ? -1 : contentB > contentA ? 1 : 0;
    });
    
    listWrapper.find("li").remove();
    listWrapper.append(sortedItems);
  }

  if ($('.sort-collection').length) {
    sortItemsOnlyByIndexDescending($('.sort-collection .vae-collection'));
  }

  $('.open-store-popup').on('click', function(){
    var $this = $(this);
    var target = $this.data('target');
    
    $(target).addClass('card-open');
  });

  $('.close-store-popup').on('click', function(){
    $(this).closest('.store-info').removeClass('card-open');
  });

  // Show the popup only once
  if(localStorage.getItem('popState') != 'shown'){
    $('.announcement-popup').delay(2000).fadeIn();
    localStorage.setItem('popState','shown');
  }

  $('.close-popup, .announcement-popup').on('click', function() {
    $('.announcement-popup').fadeOut();
  });
})(jQuery);